module.exports = __webpack_public_path__ + "img/epr_medium@2x.363719fb.webp";